import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import * as colors from '@material-ui/core/colors';
import App from './containers/App';
import configureStore from './store/configureStore';
import * as serviceWorker from './serviceWorker';

const theme = createMuiTheme({
  palette: {
    primary:
      process.env.REACT_APP_THEME_COLOR &&
      colors[process.env.REACT_APP_THEME_COLOR]
        ? colors[process.env.REACT_APP_THEME_COLOR]
        : colors.blue
    // primary: {
    //   main: '#2ec1b4',
    //   contrastText: '#fff'
    // }
  },
  typography: {
    useNextVariants: true
  }
});

const store = configureStore();

const render = Component => {
  ReactDOM.render(
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <Component />
      </MuiThemeProvider>
    </Provider>,
    document.getElementById('root')
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./containers/App', () => render(App));
}

serviceWorker.registerServiceWorker();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
